import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logs-dashboard-card',
  templateUrl: './logs-dashboard-card.component.html',
  styleUrls: ['./logs-dashboard-card.component.scss']
})
export class LogsDashboardCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
